import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

class OxiUsageDisplay extends Component {

    //Function to display form res alert logo with the good color
    getFormResImg(){
        let hours_display = "-"

        if (this.props.formresBreathingDisplay.res !== undefined && this.props.formresBreathingDisplay.res !== "-"){
            //Converting data to a clear hour data
            var hours = ((this.props.formresBreathingDisplay.res + "").split(".")[0]);
            var mins = ((this.props.formresBreathingDisplay.res + "").split(".")[1]);
            mins = mins / 100 * 60
            mins = mins.toFixed(0)
            if (mins.toString().length === 1) {
                mins = mins + "0";
            }
            hours_display = hours + "h" + mins + "m"
        }

        return (
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"1%"}}>
                <Col style={{ width:"100%" }}>
                    <FormattedMessage id="patientConstants.VNIusage" defaultMessage="Usage" />
                </Col>
                <Col style={{ width:"100%" }}>
                    <span id="row-measure-style" style={{color: "#2896E5"}}>{hours_display}</span>
                </Col>
            </Row>
        )
    }

    display_value(){

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
            </Row>
        )
    }    

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (OxiUsageDisplay);